import { render, staticRenderFns } from "./ReleaseNotesHeader.vue?vue&type=template&id=095022e8"
import script from "./ReleaseNotesHeader.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports